import { merge } from 'lodash';

import { ExternalIntegration } from 'dashboard/models/external-integration';
import {
  ExternalIntegrationActions,
  ExternalIntegrationsActionType,
} from 'dashboard/redux/actions/external-integrations';

export interface ExternalIntegrationsState {
  externalIntegrations: ExternalIntegration[];
}

export const initialExtIntegrationState: ExternalIntegrationsState = {
  externalIntegrations: [],
};

export default (
  state: ExternalIntegrationsState = initialExtIntegrationState,
  action: ExternalIntegrationActions,
) => {
  switch (action.type) {
    case ExternalIntegrationsActionType.SetExternalIntegration: {
      return {
        ...state,
        externalIntegrations: state.externalIntegrations.some(
          (existingInt) => existingInt.id === action.payload.externalIntegration.id,
        )
          ? state.externalIntegrations.map((existingInt) => {
              if (existingInt.id === action.payload.externalIntegration.id) {
                return merge(existingInt, action.payload.externalIntegration);
              } else {
                return existingInt;
              }
            })
          : [...state.externalIntegrations, action.payload.externalIntegration],
      };
    }
    case ExternalIntegrationsActionType.SetExternalIntegrations: {
      if (action.payload.merge) {
        const newIds = action.payload.externalIntegrations.map((o) => o.id);
        return {
          ...state,
          externalIntegrations: [
            ...action.payload.externalIntegrations,
            ...state.externalIntegrations.filter((o) => !newIds.includes(o.id)),
          ],
        };
      } else {
        return {
          ...state,
          externalIntegrations: action.payload.externalIntegrations,
        };
      }
    }
    case ExternalIntegrationsActionType.ClearExternalIntegrations: {
      return {
        ...state,
        externalIntegrations: [],
      };
    }
    default:
      return state;
  }
};
